import { merge } from 'lodash-es';

import { defaultToolbar } from '../constants/defaults.js';
import { HistogramChartToolbarConfig } from '../types/histogram.js';

/**
 * Builds a toolbar configuration based on context and slots
 * @param contextToolbar - toolbar context
 * @param slotToolbar - toolbar slots
 */
export function getToolbarConfiguration(
  contextToolbar: HistogramChartToolbarConfig | undefined,
  slotToolbar: HistogramChartToolbarConfig | undefined,
): HistogramChartToolbarConfig {
  return merge({}, defaultToolbar, contextToolbar, slotToolbar);
}
